import MatrixBackground from "../components/MatrixBackground";
import InteractiveTerminal from "../components/InteractiveTerminal";

const AboutTerminal = () => (
  <div className="min-h-screen pt-24 px-4 relative text-slate-100 bg-[#050a0e]">
    <MatrixBackground />
    <div className="relative z-10">
      <InteractiveTerminal />
    </div>
  </div>
);

export default AboutTerminal;
